import { api } from './';

interface ApiError {
  response?: {
    data: {
      status: number;
      error?: string;
      message: string;
      path?: string;
      timestamp?: string;
      details?: string[];
    };
    status: number;
    statusText: string;
  };
}

export const editarRodape = async (params: any) => {
  try {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await api.put('/rodape/editar', params, {headers});
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao editar rodapé';
    throw new Error(errorMessage);
  }
};

export const listarRodape = async () => {
  try {
    const response = await api.get(`/rodape/listar`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar rodapé';
    throw new Error(errorMessage);
  }
};

export const listaFixaRodape = async () => {
  try {
    const response = await api.get(`/rodape/ativos`);
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    const errorMessage = apiError.response?.data?.message || 'Erro ao listar lista fixa do rodapé';
    throw new Error(errorMessage);
  }
};